import React, { useCallback, useState } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import LoadingIndicator from "assets/svg/loading-indicator";
import { useDropzone } from "react-dropzone";
import AddPhotoDropZone from "assets/svg/add-photo-dropzone-svg";
import { Close } from "assets/svg/sidebar/icons";
import {maxUploadSize } from "utils/constant";
import { useDialogHook } from "utils/customhooks";
import UploadSizeModal from "components/file-upload/upload-size-modal";
import { useProfileGallery } from "redux/modules/profile-gallery/hooks";
import useProfileGalleryHook from "utils/useProfileGaller";
export default function EditProfilePhoto({
  hide,
  userData,
  profile,
  onUploadImage,
  profileImages=[],
  profileImage,
  setProfile = ()=>{},
  updateProfilePhoto,
  http,
  ...props }) {
  const [photo, setPhoto] = useState(null);
  const [preview, setPreview] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const uploadSizeModal = useDialogHook(UploadSizeModal);
  const [images, setImages] = useState(profileImages);
  const [selectedImage, setSelectedImage] = useState({url:profile.profile_image_file, media_id:profile.profile_photo_id, profile_photo_status:'gallery'});
  const [isLoading,setLoading] = useState(false);
  
    const {
      setPhotos: setProfileGallery,
      photos: profileGallery,
      total:totalPG,
      limit:limitPG,
      finishGetPhoto,
      isRequesting: isRequestingPG,
      loadMore: loadMorePG

    } = useProfileGallery();

    const {getProfileGallery} = useProfileGalleryHook({
        userID : userData?.profile.id, isRequestingPG, loadMorePG,
        totalPG, limitPG, setProfileGallery, finishGetPhoto,http
      })


    console.log(profileGallery)
  
  const onDrop = useCallback(acceptedFiles => {
    for(const file of acceptedFiles) {
      if (file.size > maxUploadSize) {
        showUploadSizeModalError();
        return;
      }
    }

    setPhoto(acceptedFiles);
  }, []);

  React.useEffect(()=>{
    setImages(profileGallery)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[profileGallery]);

  React.useEffect(() => {
    console.log('useEffect photo: ', photo);
    if (photo) {
      onUploadImage(photo, "profile");
      hide()
      // setPhotoPreview(photo);
    }
  }, [photo]);

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    noClickL: true,
    accept: {
      'image/*': [],
    }
  });

  /**
   * 
   * @param {string} index 
   */
  const removeUploadedPhoto = (index) => {
    const copy = photo;
    console.log('state', copy);
    const updatedPhotos = photo.filter((_, i) => i !== index); 
    console.log('newState: ', updatedPhotos);
    setPhoto(updatedPhotos);
  }

  const submit = async () => {
    setSubmitLoading(true);

    let errors = {};
    setErrorMessages(errors);
    try {
      let success =  await updateProfilePhoto(null,selectedImage);
      if(success){
        hide();
      }
    }catch(e){
      console.log(e);
    } finally {
      setSubmitLoading(false);
    }
  };
  const showUploadSizeModalError = () => {
    uploadSizeModal({}, (callback) => {
      console.log('callback', callback)
    })
  }

  const changeCoverPhoto = (prev)=>{
    setSelectedImage(prev);
    setProfile(prev)
  }

  return (
    <Modal
      width="w-19/20 md:w-18/20 2md:w-17/20 3md:w-15/20 4md:w-13/20 1xl:w-11/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible">
      <div className="w-full">
        {/* header */}
        <ModalHeader title="Edit Profile Photo" hide={hide} />
        {/* content */}
        <div className="">
          {/* profile */}
          <div className="flex flex-column">
            <div className="flex flex-col md:md:flex-row">
                <div className="w-full border-r border-gray px-8.5 pt-4 overflow-y-auto h-96">
                    <p className="font-semibold text-base">
                        Choose Profile Photo
                    </p>
                    <p className="text-xs mb-4">
                        You can select from the recent uploaded photos
                    </p>
                    <div className="grid grid-cols-2 gap-2">
                        {
                          images.length > 0 && images?.map(item=>{
                              return(
                                <div key={item.media_id} className={`border border-gray rounded-md p-1 cursor-pointer flex items-center justify-center w-full  ${selectedImage?.url === item?.url ? 'opacity-100' : 'opacity-50'}`}
                                  onClick={()=>changeCoverPhoto(item)}
                                >
                                  <img src={item.webp_url || item.url} alt="CoverPhoto" className="object-cover w-[150px] h-[150px] rounded-md"/>
                                </div>
                              );
                          })
                        }
                    </div>
                    {
                      loadMorePG && 
                        <div className="flex w-full justify-center mt-4">
                          <Button
                            disabled={isLoading}
                            buttonName="Load More"
                            buttonClass="bg-thBg py-4 px-8 hover:bg-gray"
                            buttonTextClass="text-black text-sm font-semibold"
                            onClick={async()=>{
                              try{
                                setLoading(true);
                                await getProfileGallery();
                                setLoading(false);
                              }catch(e){
                                console.log("Edit Profile Error:", e);
                                setLoading(false);
                              }
                            }}
                          />
                      </div>
                    }
                    
                </div>
                <div className="w-full px-8.5 pt-4 pb-4">
                    {/* dropzone */}
                    <p className="font-semibold text-base">
                        Upload a Photo
                    </p>
                    <p className="text-xs mb-4">
                        Browser a new photo from your files
                    </p>
                    <div {...getRootProps()}>
                    <input {...getInputProps()}/>
                    <div className="add-photo-dropzone">
                        <AddPhotoDropZone/>
                    </div>
                    </div>
                    {
                    Array.isArray(preview) && preview.length > 0 && preview.map((preview, index) => (
                        <div className="flex mt-4 items-center justify-center" key={preview.id || index}>
                        <div className="flex items-center p-2 space-x-4 add-photo-thumbnail">
                            <div className="add-photo-preview">
                            <img src={preview.path} width={70} height={70} />
                            </div>
                            <div className="flex flex-column add-photo-details">
                            <span className="add-photo-details__name">{preview.name.slice(0, 16) + "..."}</span>
                            <span className="add-photo-details__size">{preview.size}</span>
                            </div>
                            <div className="cursor-pointer" onClick={() => removeUploadedPhoto(preview.id || index)}>
                            <Close className="w-4 h-4" fill={"#333333"} />
                            </div>
                        </div>
                        </div>
                    ))
                    }
                </div>
            </div>

            {/* Footer */}
            <div className="absolute left-0 w-full custom-modal-footer-separator border-t border-gray my-4"></div>
            <div className="w-full flex items-center justify-start 1sm:justify-end space-x-2 p-4">
              <Button
                buttonName="Cancel"
                buttonClass="bg-thBg py-4 px-8 hover:bg-gray"
                buttonTextClass="text-black text-sm font-semibold"
                onClick={() => hide()}
                disabled={submitLoading}
              />
              <Button
                key="save-btn-category"
                buttonName="Save"
                buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary"
                buttonTextClass="text-white text-sm font-semibold flex items-center"
                onClick={submit}
                disabled={submitLoading}
                loadingIcon={
                  submitLoading ? (
                    <LoadingIndicator className="text-white w-4 h-4 ml-2" />
                  ) : null
                }
              />
            </div>
          </div>
        </div>
        {/* end content */}
      </div>
    </Modal>
  );
}
